module.exports = __webpack_public_path__ + "static/media/hr.1cee63bc.svg";